import { useState } from 'react';
import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function Guide() {
  const { user } = useApp();
  const { t } = useI18n();
  const [section, setSection] = useState('earn');

  const sections = [
    { id: 'earn', icon: '💰', title: 'Как заработать' },
    { id: 'referral', icon: '👥', title: 'Рефералы' },
    { id: 'vat', icon: '🧾', title: 'Возврат VAT' },
    { id: 'faq', icon: '❓', title: 'FAQ' },
  ];

  return (
    <div className="page">
      <BackButton to="profile" />
      
      <div style={{
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        borderRadius: 16,
        padding: 24,
        textAlign: 'center',
        marginBottom: 24,
      }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>📚</div>
        <h1 style={{ margin: 0 }}>Гайд по заработку</h1>
        <p style={{ opacity: 0.9, margin: '8px 0 0' }}>Как получать деньги с WORKIFYPL</p>
      </div>

      {/* Section Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap' }}>
        {sections.map(s => (
          <button
            key={s.id}
            onClick={() => setSection(s.id)}
            style={{
              flex: 1,
              minWidth: 70,
              padding: '12px 8px',
              borderRadius: 12,
              border: 'none',
              background: section === s.id ? 'rgba(99,102,241,0.3)' : 'rgba(255,255,255,0.05)',
              color: '#fff',
              cursor: 'pointer',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: 24 }}>{s.icon}</div>
            <div style={{ fontSize: 11, marginTop: 4 }}>{s.title}</div>
          </button>
        ))}
      </div>

      {/* Section Content */}
      {section === 'earn' && (
        <div>
          <h2>💰 Способы заработка</h2>
          
          <div style={{ background: 'rgba(16,185,129,0.1)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0, color: '#10b981' }}>1. Работа по договору</h3>
            <p>Заключите договор (umowa zlecenia или umowa o dzieło) через нашу платформу:</p>
            <ul style={{ paddingLeft: 20 }}>
              <li><b>Umowa zlecenia</b> — договор поручения, подходит для регулярной работы</li>
              <li><b>Umowa o dzieło</b> — договор подряда, для творческих/проектных работ (50% KUP!)</li>
            </ul>
            <p><b>Выгода:</b> До 50% налоговых вычетов при umowa o dzieło!</p>
          </div>

          <div style={{ background: 'rgba(139,92,246,0.1)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0, color: '#8b5cf6' }}>2. Выставляйте фактуры</h3>
            <p>Оказывайте услуги другим и получайте оплату через фактуры:</p>
            <ul style={{ paddingLeft: 20 }}>
              <li>Создавайте фактуры прямо в приложении</li>
              <li>Отправляйте клиентам ссылку на оплату</li>
              <li>Деньги поступают на ваш баланс</li>
            </ul>
            <p><b>Комиссия:</b> Всего 6% при выводе средств!</p>
          </div>

          <div style={{ background: 'rgba(245,158,11,0.1)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0, color: '#f59e0b' }}>3. Принимайте платежи</h3>
            <p>Создавайте ссылки на оплату для физических лиц (Stripe):</p>
            <ul style={{ paddingLeft: 20 }}>
              <li>Укажите сумму и описание услуги</li>
              <li>Отправьте ссылку клиенту</li>
              <li>Клиент оплачивает картой</li>
              <li>Деньги на вашем балансе!</li>
            </ul>
          </div>

          <div style={{ background: 'rgba(99,102,241,0.1)', borderRadius: 12, padding: 20 }}>
            <h3 style={{ marginTop: 0, color: '#6366f1' }}>4. Криптовалюта</h3>
            <p>Пополняйте баланс в USDT (TRC20) и обменивайте на PLN/EUR/USD:</p>
            <ul style={{ paddingLeft: 20 }}>
              <li>Комиссия на покупку USDT: 3%</li>
              <li>Комиссия на продажу USDT: 0%</li>
              <li>Выводите на крипто-кошелёк или на счёт</li>
            </ul>
          </div>
        </div>
      )}

      {section === 'referral' && (
        <div>
          <h2>👥 Реферальная программа</h2>
          
          <div style={{
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            borderRadius: 12,
            padding: 20,
            marginBottom: 16,
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>🤝</div>
            <h3 style={{ margin: '0 0 8px' }}>Приводи друзей — зарабатывай!</h3>
            <p style={{ margin: 0, opacity: 0.9 }}>
              Получай комиссию от заработка приведённых клиентов
            </p>
          </div>

          <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0 }}>Как это работает:</h3>
            <ol style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <b>Получи свою реферальную ссылку</b><br/>
                <span style={{ opacity: 0.7 }}>Она находится в твоём Профиле</span>
              </li>
              <li style={{ marginBottom: 12 }}>
                <b>Отправь ссылку друзьям/знакомым</b><br/>
                <span style={{ opacity: 0.7 }}>Они регистрируются и становятся твоими клиентами</span>
              </li>
              <li style={{ marginBottom: 12 }}>
                <b>Они работают и зарабатывают</b><br/>
                <span style={{ opacity: 0.7 }}>Выставляют фактуры, получают зарплату</span>
              </li>
              <li>
                <b>Ты получаешь комиссию!</b><br/>
                <span style={{ opacity: 0.7 }}>Процент от их заработка автоматически на твой баланс</span>
              </li>
            </ol>
          </div>

          <div style={{ background: 'rgba(139,92,246,0.1)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0, color: '#8b5cf6' }}>💎 Бонусы для менеджеров</h3>
            <p>Если ты активно приводишь клиентов, можешь стать <b>Менеджером</b>:</p>
            <ul style={{ paddingLeft: 20 }}>
              <li>Повышенная комиссия от клиентов</li>
              <li>Возможность создавать клиентов вручную</li>
              <li>Видеть статистику своей команды</li>
              <li>Персональная поддержка</li>
            </ul>
            <p><b>Хочешь стать менеджером?</b> Напиши в поддержку!</p>
          </div>

          {user?.referral_code && (
            <div style={{
              background: 'rgba(99,102,241,0.2)',
              borderRadius: 12,
              padding: 16,
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 8 }}>Твоя реферальная ссылка:</div>
              <div style={{
                background: 'rgba(0,0,0,0.3)',
                padding: 12,
                borderRadius: 8,
                fontSize: 12,
                wordBreak: 'break-all',
                marginBottom: 12,
              }}>
                https://t.me/WORKIFYPL_bot?start=ref_{user.referral_code}
              </div>
              <button
                className="btn btn-primary"
                onClick={() => navigator.clipboard.writeText(`https://t.me/WORKIFYPL_bot?start=ref_${user.referral_code}`)}
              >
                📋 Скопировать ссылку
              </button>
            </div>
          )}
        </div>
      )}

      {section === 'vat' && (
        <div>
          <h2>🧾 Возврат до 50% VAT</h2>
          
          <div style={{
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            borderRadius: 12,
            padding: 20,
            marginBottom: 16,
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>💸</div>
            <h3 style={{ margin: '0 0 8px' }}>Зарабатывай на своих расходах!</h3>
            <p style={{ margin: 0 }}>
              Приноси фактуры с VAT — получай до 50% обратно
            </p>
          </div>

          <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0 }}>Что это значит?</h3>
            <p>
              Когда ты покупаешь что-то для работы (оборудование, материалы, услуги), 
              ты платишь VAT (23%). Эти фактуры можно "списать" как расходы фирмы.
            </p>
            <p>
              <b>Мы возвращаем тебе до 50% от суммы VAT!</b>
            </p>
          </div>

          <div style={{ background: 'rgba(16,185,129,0.1)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0, color: '#10b981' }}>Пример расчёта:</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>Купил ноутбук за:</td>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)', textAlign: 'right' }}>5 000 PLN brutto</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>VAT (23%):</td>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)', textAlign: 'right' }}>935 PLN</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>Возврат 50% VAT:</td>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.1)', textAlign: 'right', color: '#10b981', fontWeight: 'bold' }}>+467 PLN</td>
                </tr>
                <tr>
                  <td style={{ padding: '8px 0', fontWeight: 'bold' }}>Итого ты получаешь:</td>
                  <td style={{ padding: '8px 0', textAlign: 'right', color: '#10b981', fontWeight: 'bold', fontSize: 18 }}>467 PLN на баланс!</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
            <h3 style={{ marginTop: 0 }}>Как получить возврат:</h3>
            <ol style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <b>Сфотографируй фактуру</b><br/>
                <span style={{ opacity: 0.7 }}>Фактура должна быть выставлена на фирму (с NIP)</span>
              </li>
              <li style={{ marginBottom: 12 }}>
                <b>Загрузи в раздел "Чеки"</b><br/>
                <span style={{ opacity: 0.7 }}>Мы проверим документ</span>
              </li>
              <li style={{ marginBottom: 12 }}>
                <b>Получи одобрение</b><br/>
                <span style={{ opacity: 0.7 }}>Администратор проверяет и одобряет</span>
              </li>
              <li>
                <b>Деньги на балансе!</b><br/>
                <span style={{ opacity: 0.7 }}>До 50% VAT зачисляется автоматически</span>
              </li>
            </ol>
          </div>

          <div style={{ background: 'rgba(239,68,68,0.1)', borderRadius: 12, padding: 16 }}>
            <h4 style={{ marginTop: 0, color: '#ef4444' }}>⚠️ Важно!</h4>
            <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
              <li>Фактура должна быть оригинальной (не копия)</li>
              <li>Фактура должна быть на фирму (не на физлицо)</li>
              <li>Расходы должны быть связаны с деятельностью</li>
              <li>Процент возврата зависит от типа расхода</li>
            </ul>
          </div>
        </div>
      )}

      {section === 'faq' && (
        <div>
          <h2>❓ Частые вопросы</h2>
          
          {[
            {
              q: "Как быстро я получу деньги?",
              a: "Выплаты по договорам — в течение 1-3 рабочих дней после одобрения. Вывод с баланса — до 24 часов."
            },
            {
              q: "Какая комиссия при выводе?",
              a: "При выводе на банковский счёт — 6%. На крипто-кошелёк — без комиссии (только сетевая комиссия)."
            },
            {
              q: "Нужно ли платить налоги?",
              a: "Все налоги (PIT, ZUS) автоматически рассчитываются и удерживаются при выплате по договору. Вам не нужно ничего делать самостоятельно."
            },
            {
              q: "Что такое 50% KUP?",
              a: "KUP (Koszty Uzyskania Przychodu) — налоговые вычеты. При umowa o dzieło можно списать 50% дохода как расходы, что значительно снижает налог!"
            },
            {
              q: "Как стать менеджером?",
              a: "Приведи 5+ активных клиентов и напиши в поддержку. Мы рассмотрим твою заявку и назначим комиссию."
            },
            {
              q: "Безопасно ли это?",
              a: "Да! Мы работаем официально, все договоры соответствуют польскому законодательству, платим все налоги."
            },
          ].map((item, i) => (
            <div key={i} style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: 12,
              padding: 16,
              marginBottom: 12,
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{item.q}</div>
              <div style={{ opacity: 0.8 }}>{item.a}</div>
            </div>
          ))}

          <div style={{
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            borderRadius: 12,
            padding: 20,
            textAlign: 'center',
            marginTop: 24,
          }}>
            <div style={{ fontSize: 24, marginBottom: 8 }}>📞</div>
            <h3 style={{ margin: '0 0 8px' }}>Остались вопросы?</h3>
            <p style={{ margin: '0 0 16px', opacity: 0.9 }}>Напиши нам в поддержку!</p>
            <button className="btn" style={{ background: 'rgba(255,255,255,0.2)' }} onClick={() => window.location.hash = '#support'}>
              💬 Написать в поддержку
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
